export const LS_KEYS = {
  REDIRECT_AFTER_LOGIN_URL: 'redirectAfterLoginUrl',
};
